<template>
	<div class="d-flex flex-row">
		<v-text-field
			v-for="(locale, index) in locales"
			:key="index"
			v-model="item[locale.short_name]"
			:data-vv-name="`${name}.${locale.short_name}`"
			:prefix="locale.short_name"
			class="mx-2"
		></v-text-field>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			default: function () {
				return {};
			},
			required: true,
		},
		label: {
			type: String,
			default: "name",
			required: false,
		},
		name: {
			type: String,
			default: "name",
			required: false,
		},
	},
	data() {
		return {
			tab: 0,
		};
	},
	watch: {
		item: {
			handler() {
				this.$emit("input", this.item);
			},
			immediate: true,
		},
	},
	computed: {
		item() {
			return this.value || {};
		},
		locales() {
			return [
				{
					full_name: "English",
					short_name: "en",
					required: true,
				},
				{
					full_name: "ភាសាខ្មែរ",
					short_name: "km",
					required: false,
				},
				{
					full_name: "Francais",
					short_name: "fr",
					required: false,
				},
				{
					full_name: "Chinese",
					short_name: "zh",
					required: false,
				},
			];
		},
	},
};
</script>